import { Stack, Text } from '@mantine/core';
import { VerdictLine } from './VerdictLine';
import { VerifyOffer } from './VerifyOffer';

const FALLBACK_VERDICT = "Couldn't verify this selection.";
const ACTION_LABEL = 'Would you like me to remove it from the document?';

type VerifyCalloutProps = {
  /** Hands the verify context off to the normal document editor pass. */
  onAction: () => void;
  /** The canned verdict line, built server-side; it names what was searched. */
  headline?: string;
  /** The model reported a match and none of its citations resolved — so the sources were never
   *  shown to be silent, and removing the claim is not a conclusion this supports. */
  unresolved?: boolean;
  /** The model's short spoken answer, shown beneath the canned verdict copy. */
  message?: string;
  /** Sidebar is dark (Siesta chats): use light text against the dark background. */
  dark?: boolean;
};

/** The `not_found` result: the verdict line names what was searched, and nothing backs the claim. */
export function VerifyCallout({
  onAction,
  headline,
  message,
  dark,
  unresolved,
}: VerifyCalloutProps) {
  const spokenReply = message?.trim();
  return (
    <Stack gap="sm">
      <VerdictLine text={headline ?? FALLBACK_VERDICT} dark={dark} />
      {spokenReply && (
        <Text size="textSm" c={dark ? 'gray.2' : 'gray.8'}>
          {spokenReply}
        </Text>
      )}
      {!unresolved && <VerifyOffer label={ACTION_LABEL} dark={dark} onClick={onAction} />}
    </Stack>
  );
}
